import React                              from 'react';
import TableRow                           from '@mui/material/TableRow';
import Skeleton                           from '@mui/material/Skeleton';
import TableCell                          from '@mui/material/TableCell';
import {connect}                          from 'react-redux';
import {useTranslation}                   from 'react-i18next';
import Button                             from '../../../inputs/Button';
import Link                               from '../../../typography/Link';
import {Edit}                             from '@mui/icons-material';
import VisibilityIcon                     from '@mui/icons-material/Visibility';
import VisibilityOffIcon                  from '@mui/icons-material/VisibilityOff';
import {getSiteNotificationListEditRoute} from '../../../../../router/routes/site/factory/content';

const Row = ({segment, loading}) => {
	const displaySegments = (!loading && segment);
	const {t} = useTranslation();

	return (
        <TableRow>
            <TableCell>
				{!displaySegments && <Skeleton variant="circular" width={40} height={40}/>}
				{(displaySegments && segment.Visible === 'Y') && <VisibilityIcon/>}
				{(displaySegments && segment.Visible === 'N') && <VisibilityOffIcon/>}
			</TableCell>
            <TableCell>
				{!displaySegments && <Skeleton/>}
				{displaySegments &&
				<span>{segment.Name}</span>}
			</TableCell>
            <TableCell>
				{!displaySegments && <Skeleton/>}
				{displaySegments && <span>{segment.Email}</span>}
			</TableCell>
            <TableCell align="right">
				{!displaySegments && <Skeleton/>}
				{
					displaySegments &&
					<Button variant="contained"
					        color="primary"
					        startIcon={<Edit/>}
					        component={Link}
					        to={getSiteNotificationListEditRoute(segment.Network_MassMail_Segment__)}
					>
						{t('view_btn')}
					</Button>
				}
			</TableCell>
        </TableRow>
    );
};

const mapStateToProps = (state, {loading, idx}) => {
	if (loading) return {};
	return {
		order: state.order.orders[idx],
	};
};

export default connect(mapStateToProps, null)(Row);